import { formatDate, IconAttention } from '@ui/src';
import { OngoingMonitring } from '../../customers/types';

import cn from '../information.module.css';

const formatOngoingMonitroing = (
  list: OngoingMonitring[],
): OngoingMonitring[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const warningsWithoutActions = result?.warnings?.edges?.filter(
      (warning) => !warning?.node?.action,
    );

    result.render = {
      createdAt: <div>{formatDate(result.createdAt, true)}</div>,
      matches: (
        <div>{result.warnings?.pageInfo?.totalCount || 'No matches found'}</div>
      ),
      result: (
        <div className={cn.ongoingResultRow}>
          {warningsWithoutActions.length > 0 ? (
            <span>
              <IconAttention />
              {`Require a solution: ${warningsWithoutActions.length}`}
            </span>
          ) : (
            'All are closed'
          )}
        </div>
      ),
      blocklistNumber: (
        <div>{item.warningsGroupsBlacklists?.pageInfo?.totalCount || '0'}</div>
      ),
    };

    return result;
  });

  return nextList;
};

export default formatOngoingMonitroing;
